import { useEffect } from "react";
import { toast } from "react-toastify";
import { SOCKET_LISTEN_TYPE, SOCKET_SEND_TYPE } from "../../constants/soket-message";
import { useSocket } from "../../state/socket-service";

interface CallStaffReceived {
  call_id: string;
  origin: "PC" | "MINI_APP";
  computer_id: string;
  computer_name: string;
  area_name: string;
  reason: "HELP" | "PAYMENT" | "ORDER" | "LOGIN" | "MACHINE" | "OTHER";
  screen: string;
  username_masked: string;
  order_display_code: string | null;
  at: number;
}

interface CallStaffClosed {
  call_id: string;
  by: "STAFF" | "PC" | "TIMEOUT";
  employee_id: string | null;
  at: number;
}

const REASON_LABEL: Record<CallStaffReceived["reason"], string> = {
  HELP: "Cần hỗ trợ",
  PAYMENT: "Thanh toán",
  ORDER: "Gọi món",
  LOGIN: "Đăng nhập",
  MACHINE: "Máy có lỗi", // CR-5
  OTHER: "Khác",
};

// C-23: the call lives 600 s in Redis. TIMEOUT is reserved and never emitted in Drop 1 (CR-4): the toast drops itself 600 s after it arrived.
// ponytail: client-side expiry; add a server TIMEOUT emitter when realtime runs multi-instance.
const CALL_TTL_MS = 600_000;

function beep() {
  try {
    const ctx = new AudioContext();
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.frequency.value = 880;
    gain.gain.value = 0.15;
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.onended = () => ctx.close();
    osc.start();
    osc.stop(ctx.currentTime + 0.35);
  } catch {
    // Autoplay blocked until the first click on the page: the toast still shows.
  }
}

export const CallStaffListener = () => {
  const { socket } = useSocket();

  useEffect(() => {
    if (!socket) return;
    const onCall = (e: CallStaffReceived) => {
      beep();
      const detail = [REASON_LABEL[e.reason], e.order_display_code, e.username_masked, e.origin === "MINI_APP" ? "từ Zalo" : null]
        .filter(Boolean)
        .join(" · ");
      toast.warning(
        ({ closeToast }) => (
          <div>
            <div className="font-semibold">
              {e.computer_name} · {e.area_name} gọi nhân viên
            </div>
            <div className="text-sm">{detail}</div>
            <button
              type="button"
              className="btn btn-primary btn-sm mt-2"
              onClick={() => {
                socket.emit(SOCKET_SEND_TYPE.CALL_STAFF_ACK, { call_id: e.call_id });
                closeToast?.();
              }}
            >
              Đã nhận
            </button>
          </div>
        ),
        { toastId: e.call_id, autoClose: CALL_TTL_MS, closeOnClick: false },
      );
    };
    const onClosed = (e: CallStaffClosed) => toast.dismiss(e.call_id);
    socket.on(SOCKET_LISTEN_TYPE.CALL_STAFF_RECEIVED, onCall);
    socket.on(SOCKET_LISTEN_TYPE.CALL_STAFF_CLOSED_RECEIVED, onClosed);
    return () => {
      socket.off(SOCKET_LISTEN_TYPE.CALL_STAFF_RECEIVED, onCall);
      socket.off(SOCKET_LISTEN_TYPE.CALL_STAFF_CLOSED_RECEIVED, onClosed);
    };
  }, [socket]);

  return null;
};
